module.exports = __webpack_public_path__ + "media/images/hotel-feef28df76ddda2899d6ab36b2d79894.svg";